var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end p-5 w-full gap-5"},[_c('button',{staticClass:"bg-white border-1.5 rounded-full px-10 text-sm py-2"},[_vm._v(" Add ")]),_c('button',{staticClass:"bg-primary rounded-full px-10 text-sm text-white py-2"},[_vm._v(" Save ")])])
}]

export { render, staticRenderFns }